export default __webpack_public_path__ + "static/media/heatstream.cb342fc6.svg";